export default "__VITE_ASSET__b$IjUY66__"